import youtube from '../Assets/Imgs/youtube.png';
import insta from '../Assets/Imgs/insta.jpg';
import tiktok from '../Assets/Imgs/tiktok2.png';

import allyCheer from '../Assets/Imgs/allyCheer.jpg';
import atlasCheer from '../Assets/Imgs/atlasCheer.png';

const CheerTag = () => {

  const coinFlip = (e) => {
    console.log('bab')
    e.target.classList.toggle('iconCheerAnimation');
    e.target.classList.toggle('coinFlip');
    setTimeout(()=>{
      e.target.classList.toggle('iconCheerAnimation');
    }, 755)
  }

  return (
    <div className="carouselBottomBar" >
        <div className="iconCheer iconCheerAnimation" onClick={(e)=>{coinFlip(e)}} >
          <img src={allyCheer} />
        </div>
        <div className="iconCheer iconCheerAnimation" onClick={(e)=>{coinFlip(e)}} >
          <img src={atlasCheer} style={{width:'135%'}} />
        </div>
        <div className="socialsFlip">
          <a
            className=""
            href="https://www.youtube.com/channel/UCvySiTZTEIsPKUuBhXsbtZQ"
            target="_blank"
          >
            <img src={youtube} alt="youtube" className="icon" />
          </a>
          <a
            className=""
            href="https://www.instagram.com/noise_star_band/"
            target="_blank"
          >
            <img src={insta} alt="insta" className="icon" />
          </a>
          <a
            className=""
            href="https://www.tiktok.com/@noise_star"
            target="_blank"
          >
            <img src={tiktok} alt="tiktok" className="icon" />
          </a>
        </div>
      </div>
  );
}

export default CheerTag;